import Quiz from '@/apps/quiz';

const quizMount = document.getElementById('app-quiz');

if (quizMount) {
    new Quiz(quizMount);
}
